import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import AvailableFieldsRequest from "../request/AvailableFieldsRequest";
import AvailableField from "../model/AvailableField";

export const AvailableFieldsApiService = async (
  request: AvailableFieldsRequest
): Promise<AvailableField[]> => {
  const url = "/segments/available-fields/";
  const { data } = await axios.get(url, {
    params: request,
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAvailableFieldsApiService = (
  request: AvailableFieldsRequest,
  enabled = true
) =>
  useQuery<AvailableField[], AxiosError>(
    ["AvailableFieldsApiService", ...Object.values(request)],
    () => AvailableFieldsApiService(request),
    { staleTime: 5 * 60 * 1000, enabled, keepPreviousData: true }
  );

export default useAvailableFieldsApiService;
